import { Box } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import {
  AuthenticationForm,
  AuthenticationFormHandle,
} from "../../AuthenticationDialog/AuthenticationForm";

interface OtpStepProps {
  email: string | undefined;
  confirmLabel: string;
  onComplete: () => void;
}

export const OtpStep = ({ email, confirmLabel, onComplete }: OtpStepProps) => {
  const formRef = useRef<AuthenticationFormHandle>(null);

  useEffect(() => {
    if (email) formRef.current?.setEmail(email);
    formRef.current?.setIndex("otp", { noAnimate: true });
  }, [email]);

  return (
    <Box px="20px">
      <AuthenticationForm
        confirmLabel={confirmLabel}
        // setTimeout(20) defers onComplete a tick so the AuthenticationForm
        // can finish its own state updates (auth, user) before the wizard
        // re-derives missingFields from the fresh store.
        onComplete={() => setTimeout(onComplete, 20)}
        ref={formRef}
        screens={[]}
      />
    </Box>
  );
};
